import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getAuthToken, getUser, regenAuthToken, updateUser } from '.';
import { Tables, TablesUpdate } from '@/types/database.types';
import { CustomMutationOptions, CustomQueryOptions } from '@/types/query';

export const useGetUser = (option?: CustomQueryOptions<Tables<'user'>>) => {
  return useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    ...option,
  });
};

export const useUpdateUser = (
  options?: CustomMutationOptions<TablesUpdate<'user'>>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
    ...options,
  });
};

export const useGetAuthToken = (option?: CustomQueryOptions<any>) => {
  return useQuery({
    queryKey: ['user-auth-token'],
    queryFn: getAuthToken,
    ...option,
  });
};

export const useRegenerateAuthToken = (
  options?: CustomMutationOptions<any>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: regenAuthToken,
    onSuccess: async (data, variables, context) => {
      await options?.onSuccess?.(data, variables, context);
      await queryClient.setQueryData(
        ['user-auth-token'],
        (oldData: any | undefined) =>
          oldData ? { ...oldData, ...data } : undefined
      );
    },
  });
};
